import { createContext } from 'react';
export class DataContainer {
    constructor(id) {
        this.id = id;
        this.selector = `script[data-container-id="${this.id}"][data-type="isomorphic-data"]`;
    }
    attrs() {
        return {
            key: this.id,
            'data-container-id': this.id,
            'data-type': 'isomorphic-data',
            type: 'application/json',
        };
    }
    query() {
        return document.querySelector(this.selector);
    }
}
export const IsomorphicDataContext = createContext(undefined);
//# sourceMappingURL=isomorphic-data-context.js.map